exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-danger {\n    color: #f9f7f7!important;    \n    font-size: 14px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/change-password/change-password.component.css
// module id = ../../../../../src/app/pages/change-password/change-password.component.css
// module chunks = main